import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CompletedActionCard',
  props: {
    buttonId: null,
    title: null,
    note: null,
    imageSrc: null,
    badge: { default: '' },
    emphasis: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({ (e: 'click'): void }), expose: any, slots: any, attrs: any }) {

/**
 * 完了画面の 1 アクション = 1 タイル（2×2 グリッドの 1 マス）。タイル全体が 1 つの button で、
 * GTM のトリガーが見ている id は必ずこの外側 button に付く（中に button を入れない）。
 * emphasis はおすすめ導線。大きさは他と揃えたまま、枠とタイトルの塗りだけで主従を付ける。
 */




return { __sfc: true,emit }
}

})